var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "c-modal",
    {
      attrs: {
        "class-name": "m-write-off-inventory-item",
        active: _vm.active,
        "disable-scroll": _vm.disableScroll,
        "hide-header": "",
      },
      on: { close: _vm.close },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function () {
            return [
              _c("c-button", {
                staticClass: "write-off-item__cancel",
                attrs: { label: "Отменить" },
                on: { click: _vm.close },
              }),
              _c("c-button", {
                staticClass: "write-off-item__submit",
                attrs: {
                  color: "primary",
                  label: "Списать",
                  pending: _vm.pending,
                },
                on: { click: _vm.submit },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("div", { staticClass: "write-off-item" }, [
        _c("div", { staticClass: "modal-frame__header" }, [
          _c("h2", { staticClass: "modal-frame__title" }, [
            _vm._v(" Списать ТМЦ "),
            _c("span", { staticClass: "font-weight-normal" }, [
              _vm._v("№" + _vm._s(_vm.item && _vm.item.serialNumber)),
            ]),
            _vm.item && _vm.item.name
              ? _c("div", { staticClass: "item-name" }, [
                  _vm._v(_vm._s(_vm.item.name)),
                ])
              : _vm._e(),
          ]),
        ]),
        _c("div", { staticClass: "write-off-item-form" }, [
          _c("div", { staticClass: "d-flex flex-wrap" }, [
            _c(
              "div",
              {
                staticClass: "form-group write-off-item-form__date",
                class: { "form-group--invalid": _vm.dateError },
              },
              [
                _c("c-input", {
                  ref: "calendar",
                  attrs: {
                    label: "Дата списания",
                    type: "date",
                    "required-mark": true,
                    clearable: true,
                    required: _vm.isSubmitted && _vm.dateError,
                    "required-message": _vm.isSubmitted && _vm.dateError,
                    format: "DD.MM.YYYY, dddd",
                    editable: true,
                    icon: "calendar",
                    placeholder: "00.00.0000",
                    "icon-right": true,
                  },
                  model: {
                    value: _vm.form.date,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "date", $$v)
                    },
                    expression: "form.date",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "form-group write-off-item-form__actor" },
              [
                _c("c-input", {
                  attrs: {
                    type: "select",
                    "floating-label": "Кем списан",
                    searchable: true,
                    clearable: true,
                    items: _vm.actors,
                  },
                  model: {
                    value: _vm.form.actor,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "actor", $$v)
                    },
                    expression: "form.actor",
                  },
                }),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "form-group inventory-item-form__comment" },
            [
              _c("c-textarea", {
                attrs: {
                  type: "textarea",
                  clearable: true,
                  "floating-label": "Комментарий",
                  "max-length": "500",
                },
                model: {
                  value: _vm.form.comment,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "comment", $$v)
                  },
                  expression: "form.comment",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "form-group inventory-item-form__loader" },
            [
              _c("file-loader", {
                ref: "loader",
                attrs: { format: "all", limit: 10 },
                model: {
                  value: _vm.files,
                  callback: function ($$v) {
                    _vm.files = $$v
                  },
                  expression: "files",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }